import React, { useState, useEffect } from 'react';
import DateInput from './DateInput';

// (임시 CSS)
const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '20px', borderRadius: '8px',
    width: '90%', maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto'
  },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: { width: '100%', padding: '8px', boxSizing: 'border-box' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  button: { padding: '8px 12px', cursor: 'pointer', border: 'none', borderRadius: '5px' },
  saveButton: { backgroundColor: '#007bff', color: 'white' },
  cancelButton: { backgroundColor: '#6c757d', color: 'white' }
};

const EditParticipantModal = ({ participant, isOpen, onClose, onSave, projects }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (participant) {
      setFormData({
        ...participant,
        startDate: participant.startDate ? new Date(participant.startDate).toISOString().split('T')[0] : '',
        endDate: participant.endDate ? new Date(participant.endDate).toISOString().split('T')[0] : '',
      });
    }
  }, [participant]);

  if (!isOpen || !participant) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(participant.id, formData);
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>참여자 정보 수정 (ID: {participant.id})</h3>
        <form onSubmit={handleSubmit}>
          
          <div style={modalStyles.formGroup}>
            {/* ⬇️ [연쇄 수정] '사업 유형' -> '사업명(유형)' */}
            <label style={modalStyles.label}>사업명 (유형)</label>
            <select name="projectId" style={modalStyles.input} value={formData.projectId} onChange={handleChange}>
              {projects.map(p => (
                // ⬇️ [연쇄 수정] p.businessType -> p.projectName
                <option key={p.id} value={p.id}>{p.projectName}</option>
              ))}
            </select>
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>성명</label>
            <input type="text" name="name" style={modalStyles.input} value={formData.name || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>주민등록번호</label>
            <input type="text" name="rrn" style={modalStyles.input} value={formData.rrn || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>이메일</label>
            <input
              type="email"
              name="email"
              style={modalStyles.input}
              value={formData.email || ''}
              onChange={handleChange}
            />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>은행</label>
            <input type="text" name="bankName" style={modalStyles.input} value={formData.bankName || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>계좌번호</label>
            <input type="text" name="bankAccount" style={modalStyles.input} value={formData.bankAccount || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            {/* ⬇️ [연쇄 수정] '사업명' -> '메모' */}
            <label style={modalStyles.label}>메모</label>
            <input type="text" name="memo" style={modalStyles.input} value={formData.memo || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>근무장소</label>
            <input type="text" name="workplace" style={modalStyles.input} value={formData.workplace || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>읍면동</label>
            <input type="text" name="district" style={modalStyles.input} value={formData.district || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>주소</label>
            <input type="text" name="address" style={modalStyles.input} value={formData.address || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>세부 프로그램</label>
            <input type="text" name="programDetail" style={modalStyles.input} value={formData.programDetail || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>연락처</label>
            <input type="tel" name="phone" style={modalStyles.input} value={formData.phone || ''} onChange={handleChange} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>참여시작일</label>
            <DateInput value={formData.startDate || ''} onChange={(v) => setFormData(prev => ({ ...prev, startDate: v }))} inputStyle={modalStyles.input} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>참여종료일</label>
            <DateInput value={formData.endDate || ''} onChange={(v) => setFormData(prev => ({ ...prev, endDate: v }))} inputStyle={modalStyles.input} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>담당자</label>
            <input type="text" name="registrar" style={modalStyles.input} value={formData.registrar || ''} onChange={handleChange} />
          </div>
          
          <div style={modalStyles.buttons}>
            <button type="button" style={modalStyles.cancelButton} onClick={onClose}>취소</button>
            <button type="submit" style={modalStyles.saveButton}>저장하기</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditParticipantModal;